import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
export const useTestimonyDelete = (id, clubSlug) => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== clubSlug || $[1] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: _data => {
        queryClient.invalidateQueries({
          queryKey: ["club", clubSlug, "testimonies"]
        });
      }
    };
    $[0] = clubSlug;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useMutation(t0);
};
async function _temp(id_0) {
  const response = await fetch("/api/club-testimonies", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: id_0
    })
  });
  if (!response.ok) {
    throw new Error(`Erreur ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return data;
}